import React from 'react';
import loader from './loader_pdf.gif';

const loaderStyle = {
  position: 'fixed',
  width: '100vw',
  height: '100vh',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  top: 0,
  zIndex: 10000,
  backgroundColor: '#00000063',
};

const imgLoaderStyle = {
  height: '160px',
};

const LoaderPDF = () => (
  <div style={loaderStyle}>
    <img style={imgLoaderStyle} src={loader} alt="Loader Icon" />
  </div>
);

export default LoaderPDF;



// WEBPACK FOOTER //
// src/components/PdfPrinter/LoaderPDF.js